// Mobile search sheet (views/home/m-search.php): the bottom-nav magnifier
// ([data-msearch-open]) opens it with the field focused so the keyboard
// comes up; the cross, the backdrop, Escape or reaching the desktop layout
// close it. Focus stays inside while open and returns to the magnifier.
// Without JS the magnifier is a plain link to the search page.

import { DESKTOP, onMediaChange } from './media.js';

export function initMobileSearch() {
  const dialog = document.querySelector('[data-msearch]');
  if (!dialog) return;

  const input = dialog.querySelector('input[type="search"]');
  const form = dialog.querySelector('form');
  const openers = [...document.querySelectorAll('[data-msearch-open]')];
  const desktop = window.matchMedia(DESKTOP);
  let returnFocus = null;
  let hideTimer = 0;

  const setExpanded = (value) => openers.forEach((o) => o.setAttribute('aria-expanded', String(value)));

  const open = (opener) => {
    clearTimeout(hideTimer);
    returnFocus = opener || document.activeElement;
    dialog.hidden = false;
    document.documentElement.classList.add('is-msearch-open');
    setExpanded(true);
    // Focus inside the tap so iOS raises the keyboard.
    input?.focus({ preventScroll: true });
    requestAnimationFrame(() => dialog.classList.add('is-open'));
  };

  const close = () => {
    if (dialog.hidden) return;
    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('is-msearch-open');
    setExpanded(false);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hideTimer = setTimeout(() => { dialog.hidden = true; }, reduced ? 0 : 260);
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
  };

  openers.forEach((opener) => {
    opener.setAttribute('aria-haspopup', 'dialog');
    opener.setAttribute('aria-controls', dialog.id);
    opener.setAttribute('aria-expanded', 'false');
    opener.addEventListener('click', (event) => {
      if (desktop.matches) return; // desktop keeps the link
      event.preventDefault();
      open(opener);
    });
  });

  dialog.querySelectorAll('[data-msearch-close]').forEach((el) => el.addEventListener('click', close));

  form?.addEventListener('submit', (event) => {
    if (!input || input.value.trim() === '') {
      event.preventDefault();
      input?.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (dialog.hidden) return;
    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'Tab') {
      const focusable = [...dialog.querySelectorAll('input, button, a[href]')].filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  onMediaChange(desktop, (event) => { if (event.matches) close(); });
}
